import { FC, HTMLAttributes } from "react";
import { useStyles } from "./NotificationErrorPopup.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import BellIcon from "./assets/bell.webp";
import BellIcon2x from "./assets/bell@2x.webp";
import BellIcon3x from "./assets/bell@3x.webp";

interface INotificationErrorPopupProps {
  open: boolean;
  onClose: () => void;
}

export const NotificationErrorPopup: FC<
  INotificationErrorPopupProps & HTMLAttributes<HTMLDivElement>
> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog
      className={classes.root}
      open={open}
      mainAction={{
        text: "Try again",
        onClick: onClose,
      }}
    >
      <div className={classes.content}>
        <StaticImage
          src={BellIcon}
          src2x={BellIcon2x}
          src3x={BellIcon3x}
          className={classes.currentImage}
        />
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {"Can’t enable notifications?"}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
          className={classes.description}
        >
          {"Please follow these steps:"}
        </Typography>
        <div>
          <Typography
            variant={TypographyVariant.BodyB5Regular}
            color={TypographyColor.Silver}
          >
            1. Check your browser's privacy and notification settings
          </Typography>
          <Typography
            variant={TypographyVariant.BodyB5Regular}
            color={TypographyColor.Silver}
          >
            2. {"Reset your permissions of this website"}
          </Typography>
        </div>
      </div>
    </Dialog>
  );
};
